import { useState } from 'react';
import { AxiosError } from 'axios';
import validateEmail from '@/helpers/validateEmail';
import SuccessAlert from '@/components/SuccessAlert';
import ErrorAlert from '@/components/ErrorAlert';
import accountsAPI from '@/api/accounts';
import Input from '@/components/Input';
import Button from '@/components/Button';
import LayoutStandard from '@/components/LayoutStandard';

export default function ResetPasswordPage(): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleClick = () => {
    setEmailError(false);
    if (validateEmail(email)) {
      setLoading(true);
      accountsAPI
        .forgotPassword({ forgot: { email } })
        .then(() => setSuccess(true))
        .catch((e: AxiosError) => {
          if (e.response?.status === 422) {
            setEmailError(true);
          } else {
            throw e;
          }
        })
        .finally(() => setLoading(false));
    } else {
      setEmailError(true);
    }
  };

  return (
    <LayoutStandard
      heading="Reset your Tapt password"
      description="Enter your email and we'll send you instructions on how to reset your password"
    >
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 border border-gray-100 shadow sm:rounded-lg sm:px-10">
          {success && (
            <SuccessAlert message="If your account exists please check your inbox for a password reset email" />
          )}
          {emailError && <ErrorAlert message="Please enter a valid email" />}
          <div className="space-y-6">
            <Input
              label="Email address"
              type="email"
              value={email}
              onChange={setEmail}
              error={emailError}
            />

            <div>
              <Button
                buttonText="Continue"
                onClick={() => {
                  if (!loading) handleClick();
                }}
                fullWidth
                loading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </LayoutStandard>
  );
}
